import React, { useRef, useState } from "react";
import DoctorCard from "./DoctorCard";
import { HiArrowCircleLeft, HiArrowCircleRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

const DoctorList = ({
  doctors,
  onBook,
  selectedDoctorId,
  specialitiesList,
}) => {
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  const [selectedSpeciality, setSelectedSpeciality] = useState("");

  const scroll = (direction) => {
    if (carouselRef.current) {
      const cardWidth = carouselRef.current.offsetWidth / 4;
      carouselRef.current.scrollBy({
        left: direction === "next" ? cardWidth : -cardWidth,
        behavior: "smooth",
      });
    }
  };

  const filteredDoctors =
    selectedSpeciality === ""
      ? doctors || []
      : (doctors || []).filter((doc) =>
          doc.specialities?.some(
            (s) =>
              s.specialityId === selectedSpeciality ||
              s._id === selectedSpeciality,
          ),
        );

  return (
    <div className="relative">
      {/* Header */}
      <div className="gap-4 py-4 text-center space-y-2">
        <h1 className="text-xl ">
          Meet our expert{" "}
          <span className="text-primary font-semibold">doctors</span>
        </h1>
        <h2 className="text-base text-gray-500 py-3">
          My focus has always been on providing compassionate care
        </h2>
      </div>

      <div className="flex gap-6 overflow-x-auto py-6 px-2 scrollbar-hide">
        <button
          onClick={() => setSelectedSpeciality("")}
          className="flex items-center justify-center gap-2 px-8 py-4 rounded-full whitespace-nowrap transition"
          style={{
            background:
              selectedSpeciality === ""
                ? "linear-gradient(to bottom, #9A72C9 0%, #F4C4EE 100%)"
                : "#ffffff",
            border: "1px solid #9A72C9",
            transition: "all 0.35s ease",
          }}
        >
          All
        </button>

        {specialitiesList?.map((item) => (
          <button
            key={item._id}
            onClick={() => {
              setSelectedSpeciality(item._id);

              navigate("/doctors", {
                state: {
                  specialityId: item._id,
                  specialityName: item.specialityName,
                },
              });
            }}
            className="flex items-center justify-center gap-3 px-8 py-4 rounded-full text-md whitespace-nowrap transition"
            style={{
              background:
                selectedSpeciality === item._id
                  ? "linear-gradient(to bottom, #9A72C9 0%, #F4C4EE 100%)"
                  : "#ffffff",
              border: "1px solid #9A72C9",
              transition: "all 0.35s ease",
            }}
          >
            <img
              alt="speciality"
              src={item?.specialityPic?.original}
              className="w-6 h-6 object-contain"
            />

            <span>{item.specialityName}</span>
          </button>
        ))}
      </div>

      {/* Carousel */}
      <div className="relative">
        <div
          ref={carouselRef}
          className="flex gap-5 overflow-x-auto scroll-smooth p-4 scrollbar-hide snap-x snap-mandatory"
        >
          {filteredDoctors?.length > 0 ? (
            filteredDoctors?.map((doctor) => (
              <div
                key={doctor._id}
                className="flex-shrink-0 snap-start w-full sm:w-1/2 lg:w-1/4"
              >
                <DoctorCard
                  doctor={doctor}
                  onBook={onBook}
                  selected={selectedDoctorId === doctor._id}
                />
              </div>
            ))
          ) : (
            <div className="w-full text-center py-10 text-red-500 font-semibold">
              No Doctor Found
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DoctorList;
